import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { UnprepairedMaterialService } from './unprepaired-material.service';
import { MessagesService } from '../messages/messages.service';
import { UnprepairedMaterial } from './model/unprepaired-material';

@Component({
  selector: 'app-unprepaired-material',
  templateUrl: './unprepaired-material.component.html',
  styleUrls: ['./unprepaired-material.component.css']
})
export class UnprepairedMaterialComponent implements OnInit {

  searchDate : string;
  selectedPlateOrTube : string;
  unprepairedMaterials : UnprepairedMaterial[] = [];
  errorHandler: ErrorHandler = new ErrorHandler;
  blocked:boolean = false;

  constructor(private unprepairedPlatesService: UnprepairedMaterialService,  private messagesService: MessagesService) { }

  ngOnInit() {
    this.selectedPlateOrTube = 'plate';
    this.getMaterials(this.searchDate, this.selectedPlateOrTube); 
  }

  searchOnDateEnter(searchDate){
    this.searchDate = searchDate;
    this.getMaterials(this.searchDate, this.selectedPlateOrTube);
  }
  onClickPlateOrTube(plateOrTubeSelector){
    this.selectedPlateOrTube = plateOrTubeSelector;
    this.getMaterials(this.searchDate, this.selectedPlateOrTube);

  }
  getMaterials(searchDate,selector){
    this.blocked = true;
    if (searchDate === undefined || searchDate === null){
      searchDate = '';
    }
  
    this.unprepairedPlatesService.getUnprepairedmaterial(searchDate ,selector).subscribe(
      results => {
        if (!results) {
          this.blocked = false;
          return;
        }
        this.unprepairedMaterials = results.data;
        this.blocked = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }
}
